import React from "react";
import "primeicons/primeicons.css";

const About = () => {
  return (
    <div>

      {/* 🔷 Banner Section */}
      <div style={styles.banner}>
        <div style={styles.overlay}>
          <h1 style={styles.bannerTitle}>ABOUT US</h1>
        </div>
      </div>

      {/* 🔷 Main Section */}
      <div style={styles.container}>
        <div style={styles.mainGrid}>

          {/* Left Content */}
          <div>
            <h2 style={styles.heading}>Welcome to Our Pathology Lab</h2>
            <p style={styles.description}>
              We provide accurate and timely diagnostic services using modern
              technology and expert professionals. Our goal is to ensure early
              diagnosis and better healthcare decisions.
            </p>

            <p style={styles.description}>
              With certified lab standards, quick processing, and home sample
              collection, we ensure convenience and reliability for every patient.
            </p>
          </div>

          {/* Right Image */}
          <img
            src="https://images.unsplash.com/photo-1581594693702-fbdc51b2763b"
            alt="lab"
            style={styles.image}
          />
        </div>
      </div>

      {/* 🔷 Stats Section */}
      <div style={styles.statsSection}>
        {[
          { icon: "pi pi-users", number: "1200+", label: "Happy Patients" },
          { icon: "pi pi-check-circle", number: "3500+", label: "Tests Done" },
          { icon: "pi pi-briefcase", number: "50+", label: "Experts" },
          { icon: "pi pi-home", number: "800+", label: "Home Collections" }
        ].map((item, index) => (
          <div key={index} style={styles.statBox}>
            <div style={styles.statContent}>
              <i className={item.icon} style={styles.statIcon}></i>
              <h2>{item.number}</h2>
            </div>

            {/* 🔷 Bottom Ribbon */}
            <div style={styles.ribbon}>
              {item.label}
            </div>
          </div>
        ))}
      </div>

      {/* 🔷 Why Choose Us */}
      <div style={styles.whySection}>

        {/* Center Heading */}
        <div style={styles.whyHeader}>
          <h4 style={{ color: "#2f66b1" }}>Why Choose Us?</h4>
          <h2>Our Strengths</h2>
        </div>

        <div style={styles.whyLayout}>

          {/* LEFT TEXT */}
          <div style={styles.whyLeft}>
            <h2>Advanced Pathology Services</h2>
            <p>
              We provide high-quality diagnostic services with cutting-edge
              technology and experienced professionals ensuring accuracy and
              reliability.
            </p>

            <ul style={styles.list}>
              <li> Safe & Hygienic standards</li>
              <li> Quick turnaround time for all major tests</li>
              <li> Tested under extreme conditions</li>
            </ul>
          </div>

          {/* RIGHT CARDS */}
          <div style={styles.whyRight}>

            {/* Card 1 */}
            <div style={styles.slantCardLight}>
              <div style={styles.iconBox}>
                <i className="pi pi-users"></i>
              </div>
              <div>
                <h3>Safe & Hygienic</h3>
                <p>Strict hygiene and safety protocols followed.</p>
              </div>
            </div>

            {/* Card 2 (Blue Highlight) */}
            <div style={styles.slantCardLight}>
              <div style={styles.iconBox}>
                <i className="pi pi-home"></i>
              </div>
              <div>
                <h3>Home Collection</h3>
                <p>Convenient doorstep sample pickup services.</p>
              </div>
            </div>

            {/* Card 3 */}
            <div style={styles.slantCardLight}>
              <div style={styles.iconBox}>
                <i className="pi pi-check-circle"></i>
              </div>
              <div>
                <h3>Trusted Results</h3>
                <p>Reliable reports for better healthcare decisions.</p>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  );
};

export default About;

const styles = {

  /* Banner */
  banner: {
    height: "300px",
    backgroundImage:
      "url('https://images.unsplash.com/photo-1581090700227-1e8b2b64db8c')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: "relative"
  },

  overlay: {
    background: "#74a6eb",
    height: "100%",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    paddingLeft: "8%"
  },

  bannerTitle: {
    fontSize: "45px",
    fontWeight: "bold"
  },

  /* Main Section */
  container: {
    padding: "80px 8%"
  },

  mainGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "40px",
    alignItems: "center"
  },

  heading: {
    fontSize: "35px",
    marginBottom: "50px",
    color: "#2F66B1"
  },

  description: {
    color: "#555",
    lineHeight: "1.7",
    marginBottom: "20px",
    fontSize: "22px",
  },

  image: {
    width: "100%",
    borderRadius: "12px"
  },

  /* Stats */
  statsSection: {
    display: "grid",
    gridTemplateColumns: "repeat(4,1fr)",
    gap: "25px",
    padding: "70px 8%",
    background: "#111111",
  },

  statBox: {
    position: "relative",
    border: "1px solid #2f66b1",
    padding: "25px 20px 50px",
    color: "#fff",
    background: "rgba(255,255,255,0.03)",
    overflow: "hidden"
  },

  statContent: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "10px"
  },

  statIcon: {
    fontSize: "26px",
    color: "#fff"
  },

  /* 🔥 BLUE BENDING RIBBON */
  ribbon: {
    position: "absolute",
    bottom: "0",
    left: "0",
    background: "#2f66b1",
    color: "#fff",
    padding: "10px 25px",
    fontWeight: "bold",
    fontSize: "14px",

    /* 👇 THIS CREATES THE SLANTED CUT */
    clipPath: "polygon(0 0, 85% 0, 100% 100%, 0% 100%)"
  },

  /* Why Section */

  whyHeader: {
    textAlign: "center",
    marginBottom: "40px",
    marginTop: "40px"
  },
  whyLayout: {
    display: "grid",
    gridTemplateColumns: "1.2fr 1fr",
    gap: "30px",
    alignItems: "center",
  },

  whyLeft: {
    textAlign: "left",
    paddingLeft: "40px"

  },

  list: {
    marginTop: "20px",
    lineHeight: "2",
    color: "#444"
  },

  whyRight: {
    display: "flex",
    flexDirection: "column",
    gap: "20px"
  },

  /* 🔥 SLANTED CARDS */
  slantCardLight: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    background: "#2F66B1",
    padding: "25px",
    position: "relative",
  },



  /* Icon boxes */
  iconBox: {
    background: "#e5e7eb",
    padding: "20px",
    fontSize: "24px"
  },

  iconBoxWhite: {
    background: "#ffffff",
    padding: "25px",
    fontSize: "24px",
    color: "#2f66b1"
  },
}